import React, { useEffect, useState, useCallback } from "react";
import PhoneInput from "react-phone-input-2";
import TimePicker from "react-time-picker";
import "react-time-picker/dist/TimePicker.css";
import "react-clock/dist/Clock.css";
import "react-phone-input-2/lib/bootstrap.css";
import { useDropzone } from "react-dropzone";
import Select from "react-select";
import Spinner from "../../../components/Spinner";
import { getGuestForm } from "../../../API/rateplanApi";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export default function GuestForm(props) {
  const locale = localStorage.getItem("locale")
  console.log('locale::: ', locale);
  const [guestForm, setGuestForm] = useState([]);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({});
  const [formErrors, setFormErrors] = useState({});
  const [imagePreviews, setImagePreviews] = useState({});

  useEffect(() => {
    const fetchForm = async () => {
      try {
        setLoading(true);
        const response = await getGuestForm();
        if (response.status === 200) {
          setGuestForm(response.data);
        }
      } catch (error) {
        console.error("Error fetching form:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchForm();
  }, []);

  const validateField = (fieldname, value, field) => {
    let error = "";
    if (field.required && !value) {
      error = `${field.displayname} is required.`;
    } else if (field.fieldtype === "primaryemail" && value) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(value)) {
        error = "Invalid email format.";
      }
    } else if (field.fieldtype === "number" && value) {
      if (field.min && value < field.min) {
        error = `${field.displayname} must be at least ${field.min}.`;
      }
      if (field.max && value > field.max) {
        error = `${field.displayname} must be at most ${field.max}.`;
      }
    }
    return error;
  };

  const validateForm = () => {
    let isValid = true;
    let isAnyFieldFilled = false;
    const updatedFormErrors = {};

    guestForm.forEach((field) => {
      const value = formData[field.fieldname];
      if (value) {
        isAnyFieldFilled = true;
      }
      const error = validateField(field.fieldname, value, field);
      if (error) {
        isValid = false;
      }
      updatedFormErrors[field.fieldname] = error;
    });

    setFormErrors(updatedFormErrors);
    return isValid && isAnyFieldFilled;
  };

  useEffect(() => {
    if (Object.keys(formData).length > 0) { // Avoid validation on first render
      const isValid = validateForm();
      const updatedFormData = { ...formData, IsValid: isValid };
      props.onGuestFormChange(updatedFormData);
    }
  }, [formData, guestForm]);

  const handleChange = (e, fieldname) => {
    const field = guestForm.find((f) => f.fieldname === fieldname);
    const value = e.target.value;
    const error = validateField(fieldname, value, field);

    const updatedFormData = { ...formData, [fieldname]: value };
    const updatedFormErrors = { ...formErrors, [fieldname]: error };

    setFormData(updatedFormData);
    setFormErrors(updatedFormErrors);
  };

  const handleDrop = useCallback((acceptedFiles, fieldname, multiselect) => {
    const newPreviews = acceptedFiles.map((file) => ({
      file,
      preview: URL.createObjectURL(file),
    }));

    const updatedFormData = {
      ...formData,
      [fieldname]: multiselect ? [...(formData[fieldname] || []), ...acceptedFiles] : acceptedFiles[0],
    };

    setFormData(updatedFormData);
    setImagePreviews((prev) => ({
      ...prev,
      [fieldname]: multiselect ? [...(prev[fieldname] || []), ...newPreviews] : newPreviews,
    }));

    props.onGuestFormChange(updatedFormData);
  }, [formData, props]);

  const handleSelectChange = (selectedOptions, fieldname, isMulti) => {
    const field = guestForm.find((f) => f.fieldname === fieldname);
    const value = isMulti
      ? selectedOptions.map((opt) => opt.value)
      : selectedOptions?.value || null;
    const error = validateField(fieldname, value, field);

    const updatedFormData = { ...formData, [fieldname]: value };
    const updatedFormErrors = { ...formErrors, [fieldname]: error };

    setFormData(updatedFormData);
    setFormErrors(updatedFormErrors);
  };

  const groupedSections = guestForm?.reduce((sections, field) => {
    if (!sections[field.sectionname]) sections[field.sectionname] = [];
    sections[field.sectionname].push(field);
    return sections;
  }, {});

  const sortedSections = Object.entries(groupedSections)
    .map(([sectionName, fields]) => ({
      sectionName,
      sectiondisplayname: fields[0]?.sectiondisplayname || "",
      fields: fields.sort((a, b) => a.formorder - b.formorder),
      minFormOrder: Math.min(...fields.map((f) => f.formorder)),
    }))
    .sort((a, b) => a.minFormOrder - b.minFormOrder);

  return (
    <div className="container mt-1">
      {loading && <Spinner />}
      <form>
        {sortedSections.map((section, index) => (
          <div key={index} className="card mb-3 shadow-sm">
            <h6 className="pt-3 ps-2">{section?.sectiondisplayname}</h6>
            <div className="card-body">
              <div className="row">
                {section.fields.map((field) => (
                  <div key={field._id} className={`mb-3 ${field.colspan === "2" ? "col-md-6" : "col-md-12"}`}>
                    <label className="form-label">
                      {field.displayname} {field.required && <span className="text-danger">*</span>}
                    </label>
                    <br />
                    {(() => {
                      switch (field.fieldtype) {
                        case "fullname":
                        case "text":
                        case "primaryemail":
                          return (
                            <input
                              type={field.fieldtype === "primaryemail" ? "email" : "text"}
                              className="form-control"
                              name={field.fieldname}
                              required={field.required}
                              onChange={(e) => handleChange(e, field.fieldname)}
                            />
                          );

                        case "list":
                          return (
                            <Select
                              options={field.lookupdata.map(item => ({ value: item.key, label: item.value }))}
                              value={field.lookupdata
                                .filter(item => formData[field.fieldname]?.includes(item.key))
                                .map(item => ({ value: item.key, label: item.value }))}
                              onChange={(selectedOption) => {
                                const updatedValue = Array.isArray(selectedOption)
                                  ? selectedOption.map(option => option.value)
                                  : selectedOption?.value || null;
                                const updatedFormData = { ...formData, [field.fieldname]: updatedValue };
                                setFormData(updatedFormData);
                                props.onGuestFormChange(updatedFormData);
                              }}
                              className="basic-single"
                              classNamePrefix="select"
                              isClearable={!field.required}
                              isMulti={field.multiselect}
                              placeholder="Select an option"
                            />
                          );

                        case "time_only":
                          return (
                            <TimePicker
                              onChange={(time) => {
                                const updatedFormData = { ...formData, [field.fieldname]: time };
                                setFormData(updatedFormData);
                                props.onGuestFormChange(updatedFormData);
                              }}
                              value={formData[field.fieldname] || ""}
                              disableClock={true}
                              format="HH:mm"
                              clearIcon={null}
                              required={field.required}
                              className="form-control custom-timepicker"
                            />
                          );

                        case "number":
                          return (
                            <input
                              type="number"
                              className="form-control"
                              name={field.fieldname}
                              required={field.required}
                              min={field.min || ""}
                              max={field.max || ""}
                              onChange={(e) => handleChange(e, field.fieldname)}
                            />
                          );

                        case "mobile":
                          return (
                            <PhoneInput
                            disableDropdown={true}
                            onlyCountries={["us"]}
                              country={"us"}
                              value={formData[field.fieldname] || ""}
                              onChange={(phone) => {
                                const updatedFormData = { ...formData, [field.fieldname]: phone };
                                setFormData(updatedFormData);
                                props.onGuestFormChange(updatedFormData);
                              }}
                              inputClass="form-control"
                              containerClass="phone-input-container"
                            />
                          );

                        case "datepicker":
                          return (
                            <DatePicker
                              selected={formData[field.fieldname] ? new Date(formData[field.fieldname]) : null}
                              onChange={(date) => {
                                const updatedFormData = { ...formData, [field.fieldname]: date };
                                setFormData(updatedFormData);
                                props.onGuestFormChange(updatedFormData);
                              }}
                              className="form-control input_react_date"
                              dateFormat={locale === "en-US" ? "MM-dd-yyyy" : "dd-MM-yyyy"}
                              placeholderText={locale === "en-US" ? "MM-DD-YYYY" : "DD-MM-YYYY"}
                              required={field.required}
                            />
                          );

                        case "long_text":
                          return (
                            <textarea
                              className="form-control"
                              name={field.fieldname}
                              required={field.required}
                              onChange={(e) => handleChange(e, field.fieldname)}
                            />
                          );

                        case "multi_selected_list":
                          return (
                            <Select
                              isMulti
                              options={field.lookupdata.map((opt) => ({ value: opt.key, label: opt.value }))}
                              onChange={(selectedOptions) => handleSelectChange(selectedOptions, field.fieldname, true)}
                            />
                          );

                        case "radio":
                          return field.lookupdata.map((opt, idx) => (
                            <div key={idx} className="form-check form-check-inline">
                              <input
                                className="form-check-input"
                                type="radio"
                                name={field.fieldname}
                                value={opt.key}
                                onChange={(e) => handleChange(e, field.fieldname)}
                              />
                              <label className="form-check-label">{opt.value}</label>
                            </div>
                          ));

                        case "attachment":
                          return <DropzoneField field={field} onDrop={handleDrop} imagePreviews={imagePreviews} />;

                        default:
                          return <p className="text-muted">Unsupported field type: {field.fieldtype}</p>;
                      }
                    })()}
                    {formErrors[field.fieldname] && (
                      <small className="text-danger">{formErrors[field.fieldname]}</small>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}
      </form>
    </div>
  );
}

// Dropzone Component
const DropzoneField = ({ field, onDrop, imagePreviews }) => {
  const { getRootProps, getInputProps } = useDropzone({
    accept: "image/*",
    multiple: field.multiselect,
    onDrop: (acceptedFiles) => onDrop(acceptedFiles, field.fieldname, field.multiselect),
  });

  return (
    <>
      <div {...getRootProps()} className="border rounded p-3 text-center" style={{ cursor: "pointer", backgroundColor: "#f8f9fa" }}>
        <input {...getInputProps()} />
        <p>Drag & drop an image here, or click to select one</p>
      </div>
      {imagePreviews[field.fieldname] &&
        imagePreviews[field.fieldname].map((preview, idx) => (
          <img key={idx} src={preview.preview} alt="Preview" className="img-thumbnail mt-2" style={{ width: "80px", height: "80px" }} />
        ))}
    </>
  );
};
